import coachCopy from '@/data/classCoach.json';

export const CLASS_STEP_INDEX = Object.fromEntries(coachCopy.stepsV1.map((step, index) => [step.id, index]));
export const CLASS_STEP_INDEX_FLOW2 = Object.fromEntries(coachCopy.steps.map((step, index) => [step.id, index]));

export function classFeatures({ isClass = false, focus = false, furthestStep = 0, takehomeOpen = false, flow = 1, free = false, readOnly = false, recordingEnabled = false } = {}) {
  if (free) {
    const editable = !readOnly;
    return {
      producer: editable, add: editable, library: editable, autoArrange: editable,
      newBeat: false, openProjects: false, save: false, keyboard: editable,
      record: editable && Boolean(recordingEnabled), mixer: editable, lyrics: editable,
      clipSound: editable, export: true,
    };
  }
  const focused = Boolean(isClass && focus);
  const full = !focused;
  const stepIndex = flow === 2 ? CLASS_STEP_INDEX_FLOW2 : CLASS_STEP_INDEX;
  return {
    producer: full,
    add: full,
    library: full,
    autoArrange: full,
    newBeat: !isClass,
    openProjects: !isClass,
    // Sprint 1 class previews are never saved as normal projects; seats get their own saves in Sprint 2.
    save: !isClass,
    keyboard: full,
    record: full,
    mixer: full,
    lyrics: full,
    clipSound: full || Number(furthestStep) >= stepIndex.flavor,
    export: full || Number(furthestStep) >= stepIndex.outro || Boolean(isClass && takehomeOpen),
  };
}
